
import React from 'react';
import { PageContainer } from './PageContainer';
import { PageHeadline } from './PageHeadline';

interface PageWithHeadlineProps {
    headlineKey: string;
    children: React.ReactNode;
}

const PageWithHeadline: React.FC<PageWithHeadlineProps> = ({ headlineKey, children }) => {
    return (
        <PageContainer>
            {/* Headline above the page content, filling the container height */}
            <div className="space-y-2 mx-auto relative h-full w-full grow flex flex-col text-onbackground">
                <PageHeadline headlineKey={headlineKey} subheadlineKey="" />
                {children}
            </div>
        </PageContainer>
    );
};

export default PageWithHeadline;
